!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("ati-ui-react/components/icons/Icon")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react", "ati-ui-react/components/icons/Icon"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react"), require("ati-ui-react/components/icons/Icon")) : e["ati-ui-react"] = t(e.React, e[void 0]);
}(this, function (r, n) {
  return i = {}, o.m = c = {
    0: function (e, t) {
      e.exports = r;
    },
    1: function (e, t) {
      e.exports = n;
    },
    718: function (e, t, r) {
      "use strict";

      r.r(t), r.d(t, "default", function () {
        return o;
      });
      var t = r(0),
        n = r.n(t),
        t = r(1),
        r = r.n(t),
        t = function (e) {
          var t = e.color,
            e = e.fillRule;
          return n.a.createElement("path", {
            fill: "none",
            fillRule: e,
            stroke: t,
            d: "M.59 7l.016.024c.152.229.336.485.553.76a15.178 15.178 0 0 0 2.284 2.33C6.014 12.231 9.185 13.5 13 13.5c3.815 0 6.986-1.269 9.557-3.386.9-.741 1.661-1.536 2.284-2.33A11.786 11.786 0 0 0 25.41 7a15.178 15.178 0 0 0-2.853-3.114C19.986 1.769 16.815.5 13 .5 9.185.5 6.014 1.769 3.443 3.886c-.9.741-1.661 1.536-2.284 2.33A11.786 11.786 0 0 0 .59 7zM13 .5c3.617 0 6.684 1.165 9.205 3.104a15.035 15.035 0 0 1 2.256 2.133c.22.257.407.495.564.71.096.133.162.23.197.285l.17.268-.17.268a5.77 5.77 0 0 1-.197.284c-.157.216-.345.454-.564.71a15.035 15.035 0 0 1-2.256 2.134C19.685 12.336 16.617 13.5 13 13.5s-6.684-1.165-9.205-3.104A15.035 15.035 0 0 1 1.54 8.263c-.22-.257-.407-.495-.564-.71a5.77 5.77 0 0 1-.197-.285L.608 7l.17-.268a5.77 5.77 0 0 1 .197-.284c.157-.216.345-.454.564-.71a15.035 15.035 0 0 1 2.256-2.134C6.315 1.664 9.383.5 13 .5zm0 10a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zm0 0a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7zm0-3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"
          });
        };
      t.svg = {
        viewBox: "0 0 26 14"
      };
      var o = r()(t);
    }
  }, o.c = i, o.d = function (e, t, r) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (o.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var n in t) o.d(r, n, function (e) {
      return t[e];
    }.bind(null, n));
    return r;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 718);
  function o(e) {
    if (i[e]) return i[e].exports;
    var t = i[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return c[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }
  var c, i;
});